<template>
    <tr class="vue-vehicle-rate-line">
        <td>
            {{ item.rateType }}
        </td>
        <td class="text-end font-weight-bold">
            {{ calculatePrice(item.totalPrice) | vatExcluder | currencyFormatter }}
        </td>
    </tr>
</template>

<script>
import CurrencyFormatter from "../../mixins/CurrencyFormatter";

export default {
    name: "VehicleRateLine",

    mixins: [CurrencyFormatter],

    props: {
      index: {
        type: Number,
        required: true
      },
      number_of_days: {
        type: Number,
        required: true
      },
      item: {
          type: Object,
          required: true
      }
    },
  methods: {
    calculatePrice(price) {
      if (this.item.amount <= 1 || this.index === 0) {
        return price;
      }
      return price * this.number_of_days;
    }
  }
}
</script>
